require('./js/copy-text');
require('./js/hover-detect');
require('./js/jquery.accordion');
import 'core-js';
import 'whatwg-fetch';
import './js/site-scripts';
import './sass/styles.scss';

import './app';
